import React from "react";
import BabyTracker from "../components/tracker/BabyTracker";

const ChildPage = () => {
  return <BabyTracker />;
};

export default ChildPage;
